import React, { useState } from 'react';
import { ROPatientContextProvider } from '../PatientSummary/context';
import OuterContainer from '../PatientSummary/OuterContainer';
import { HealthTimelineContainer } from './components/Timeline';

const HealthTimeline = (): JSX.Element => {
  return (
    <ROPatientContextProvider>
      <OuterContainer marginBottom="0px" rowSpace="0px">
        <HealthTimelineContainer />
      </OuterContainer>
    </ROPatientContextProvider>
  );
};

export default HealthTimeline;
